import { Link } from "react-router-dom";
import { RichText } from "@/components/RichText";
import type { SubHero } from "@/lib/types";

export default function HeroSub({ data }: { data: SubHero }) {
  return (
    <section className="hero-sub">
      <div className="hero-sub-inner">
        <div>
          <div className="hero-sub-eyebrow">{data.eyebrow}</div>
          <RichText as="h1" className="hero-sub-title" html={data.title} />
          <p className="hero-sub-lead">{data.lead}</p>
          <div className="hero-sub-ctas">
            <Link to={data.primaryCta.href} className="btn-primary">
              {data.primaryCta.label}
            </Link>
            <Link to={data.secondaryCta.href} className="btn-ghost">
              {data.secondaryCta.label}
            </Link>
          </div>
        </div>
        <div className="hero-sub-stats">
          {data.stats.map((s) => (
            <div key={s.label}>
              <div className="hero-sub-stat-num">{s.num}</div>
              <div className="hero-sub-stat-label">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
